$(document).ready(function() {
    const REPLACE_PATTERNS = {
        'lib-link': /(?<=&lt;script.*>").*?(?="<.*\/script)/,
        'client-id': /(?<='client_id'.*:.*>').*?(?='<)/,
        'script-link': /(?<=openDialog.*\(.*>').*?(?='<.*\))/,
        'login-btn-txt': /(?<=<span.*"loginWithPayseraBtnText".*>&gt;<\/span><span.*>).*?(?=<\/span>)/
    };

    var sample = {
        replaceCode: function(searchFor, replaceWith) {
            newCode = $('#loginWithPayseraCode').html().replace(searchFor, replaceWith);
            $('#loginWithPayseraCode').html(newCode);

        },
        replaceBtnText: function(ident, value) {
            $(ident).html(value);
        }
    };

    $(document).on("input", "input[type=text][data-login-with-paysera]", function() {
        value = $(this).val();

        if ($(this).attr("name")) {
            sample.replaceCode(REPLACE_PATTERNS[$(this).attr("name")], value);
        }

        if ($(this).attr("name") === 'login-btn-txt' && value) {
            sample.replaceBtnText('.loginWithPayseraBtnText', value);
        }
    });

    $(document).on("click", "input[type=text][data-login-with-paysera]", function() {
        $(this).focus().select();
    });

    $(document).on("click", "input[type=radio][data-login-with-paysera]", function() {
        $('.loginWithPayseraHide').hide();

        linkToLibID = '#' + $(this).data('login-with-paysera');
        $(linkToLibID).removeClass('hidden');
        $(linkToLibID).show();
    });
});